<template>
  <div class="view pa24">
    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center">
            <Search ref="search" :wareStatus="wareStatus" @search="searchList"></Search>
            <el-button type="primary" @click="exportLog">导 出</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border default-expand-all
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="lotNumber" align="center" label="批次号" />
      <el-table-column prop="orderNo" align="center" label="订单号">
        <template slot-scope="scope">
          {{scope.row.orderNo|| '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="num" align="center" label="重量T（半/成品）" v-if="companyName.includes('汇友')">
      </el-table-column> 
      <el-table-column prop="num" align="center" label="数量" v-if="!companyName.includes('汇友')">
      </el-table-column>
      <el-table-column prop="weight" align="center" label="重量T（原材料）" v-if="companyName.includes('汇友')">
        <template slot-scope="scope">
          {{scope.row.weight||0}}
        </template>
      </el-table-column>
      <el-table-column prop="weight" align="center" label="重量(t)" v-if="!companyName.includes('汇友')">
        <template slot-scope="scope">
          {{scope.row.weight||0}}
        </template>
      </el-table-column>
      <el-table-column prop="remarks" align="center" label="备注" />
      <el-table-column prop="createBy" align="center" label="操作人" />
      <el-table-column prop="createTime" align="center" label="出库时间" />
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="codeDetail(scope.row)">查看</el-button>
          <el-button type="text" @click="batchDetail(scope.row)">详情</el-button>
          <el-button type="text" @click="delBatch(scope.row)" v-if="companyName.includes('五洲')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>

    <el-dialog title="详情" width="30%" :visible.sync="dialogVisible" :close-on-click-modal="false"
      :destroy-on-close="true" append-to-body>
      <el-form :model="detailData" label-width="80px">
        <el-form-item label="批次号">
          <el-input v-model="detailData.lotNumber" readonly></el-input>
        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model="detailData.num" readonly></el-input>
        </el-form-item>
        <el-form-item label="重量(t)">
          <el-input v-model="detailData.weight" readonly></el-input>
        </el-form-item>
        <el-form-item label="操作人">
          <el-input v-model="detailData.createBy" readonly></el-input>
        </el-form-item>
        <el-form-item label="出库时间">
          <el-input v-model="detailData.createTime" readonly></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="detailData.remarks" type="textarea" readonly></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <div v-for="(item,index) in detailData.imgList" :key="index">
            <el-image style="width: 100px; height: 100px" :src="baseImgUrl+item" :preview-src-list="[baseImgUrl+item]">
            </el-image>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 导出 -->
    <el-dialog title="导出" width="30%" :visible.sync="dialogVisible1" :close-on-click-modal="false"
      :destroy-on-close="true" append-to-body>
      <el-form :model="exportParms" label-width="80px">
        <el-form-item label="选择产品" prop="parentName">
          <el-select class="main-select-tree" ref="selectTree" clearable @clear="setValueNull"
            v-model="exportParms.productName" style="width: 300px;" name='option 1'>
            <el-option v-for="item in optionData(classList)" :label="item.label" :value="item.label" :key="item.id"
              style="display: none;" />
            <div class="searchWrap">
              <div class="searchItem">
                <span class="searchName">名称</span>
                <el-input placeholder="输入名称关键字进行过滤" v-model="filterText" style="margin: 0 5px; width: 98%">
                </el-input>
              </div>
              <div class="searchItem">
                <span class="searchName">规格</span>
                <el-input placeholder="输入规格关键字进行过滤" v-model="specName" style="margin: 0 5px; width: 98%">
                </el-input>
              </div>
              <div class="searchItem">
                <span class="searchName">件号/存货编号</span>
                <el-input placeholder="输入件号/存货编号进行过滤" v-model="partNumber" style="margin: 0 5px; width: 98%">
                </el-input>
              </div>
              <div class="searchItem">
                <el-radio-group v-model="exportParms.classType" @change="handleClassTypeChange">
                  <el-radio :label="1">原材料</el-radio>
                  <el-radio :label="0">成品</el-radio>
                </el-radio-group>
              </div>
            </div>

            <el-tree class="main-select-el-tree" ref="selectelTree" :data="classList" :props='treeProps'
              highlight-current @node-click="handleNodeClick" :expand-on-click-node="expandOnClickNode" :lazy="true"
              :load="load" collapse-tags />
          </el-select>
        </el-form-item>

        <!-- 加一个操作人的输入框 -->
        <el-form-item label="操作人">
          <el-input v-model="exportParms.createBy" placeholder="请输入操作人" style="width: 220px;"></el-input>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker v-model="exportParms.startDate" type="date" placeholder="选择开始日期" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="exportParms.endDate" type="date" placeholder="选择结束日期" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="confirmExport">导 出</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import { selectLogBatchList, exportExcle, back } from '@/api/storeLogBatch.js'
  import { noPage } from '@/api/customPageClass.js'
  import { fetchWarehouseTree } from '@/api/storeWarehouse.js'
  import { selectCode } from '@/api/storeCode'
  import Search from "./component/search.vue";
  import { baseImgUrl } from "@/utils/constant";
  import { baseUrl } from "@/utils/index";
  import { pageClassList } from '@/api/customPageClass.js'
  export default {
    components: {
      Search

    },
    props: {

    },
    data() {
      return {
        userInfo: '',
        companyName: '',
        name: null,
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        wareStatus: 2,
        queryParam: '',
        dialogVisible: false,
        dialogVisible1: false,
        detailData: '',
        baseImgUrl: baseImgUrl,
        exportParms: {
          startDate: '',
          endDate: '',
          createBy: '',
          productName: '',
          classType: 1

        },
        filterText: "",
        partNumber: "",
        specName: "",
        classList: [{ value: 0, label: 'fadsfs' }],
        treeProps: {
          children: 'children',
          label: 'allName',
          isLeaf: 'isLeaf'
        },
        expandOnClickNode: false,
      };
    },
    created() {
      let userInfo = JSON.parse(localStorage.getItem('info'));
      this.userInfo = userInfo
      if (this.userInfo.companyList) {
        this.companyName = this.userInfo.companyList[0].companyName
      }
      this.getList()
    },
    mounted() {
    },
    watch: {
      filterText(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: this.exportParms.classType,
          parentId: "",
          name: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
      specName(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: this.exportParms.classType,
          parentId: "",
          specName: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
      partNumber(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: this.exportParms.classType,
          parentId: "",
          partNumber: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
    },
    methods: {
      // 日期格式化
      dateFormat(date, format = 'yyyy-MM-dd') {
        if (date !== 'Invalid Date' && date != null) {
          var o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds(),
            'q+': Math.floor((date.getMonth() + 3) / 3),
            'S': date.getMilliseconds()
          }
          if (/(y+)/.test(format)) {
            format = format.replace(RegExp.$1,
              (date.getFullYear() + '').substr(4 - RegExp.$1.length))
          }
          for (var k in o) {
            if (new RegExp('(' + k + ')').test(format)) {
              format = format.replace(RegExp.$1,
                RegExp.$1.length === 1 ? o[k]
                  : ('00' + o[k]).substr(('' + o[k]).length))
            }
          }
          return format
        }
        return ''
      },
      handleNodeClick(node) {
        this.exportParms.productName = node.name
      },
      searchItem(params, val) {
        pageClassList(params)
          .then((res) => {
            res.data.list.forEach((item) => {
              item.isLeaf = !item.hasChildren;
              let namePart = item.name ? `${item.name}` : "";
              let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
              let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
              let specNamePart = item.specName ? `(${item.specName})` : "";
              item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
            });
            if (res.data.list && res.data.list.length == 0) {
              this.$message.error("没有找到相关的产品类别");
            }
            if (val) {
              this.classList =
                res.data.list && res.data.list.length > 0
                  ? res.data.list
                  : this.allData;
            } else {
              this.classList = this.allData;
            }
          })
          .catch((error) => {
            console.error("接口调用出错:", error);
          });
      },
      load(node, resolve) {
        if (this.isInitialRender) {
          this.isInitialRender = false;
          return resolve([]);
        }
        console.log('node', node)
        if ('顶级' == node.data.name || '顶级' == node.data.allName) {
          return resolve(node.data.children)
        } else {
          let params = {
            noPage: false,
            type: 0,
            classType: this.exportParms.classType,
            status: this.storeStatus,
            parentId: node.data.id,
            name: this.filterText,
            specName: this.specName,
            partNumber: this.partNumber
          }
          pageClassList(params).then(res => {
            res.data.list.forEach(item => {
              item.isLeaf = !item.hasChildren
              let namePart = item.name ? `${item.name}` : "";
              let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
              let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
              let specNamePart = item.specName ? `(${item.specName})` : "";
              item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
            })
            node.data.children = res.data.list;
            return resolve(res.data.list)
          })
        }

      },
      getAllClass() {
        this.classList = []
        let params = {
          pageNum: 1,
          pageSize: 200,
          type: 0,
          classType: this.exportParms.classType
        }
        pageClassList(params).then(res => {
          // this.classList = [{id:'',name:'顶级'}]
          // this.classList.push(res.data.list)
          res.data.list.forEach(item => {
            item.isLeaf = !item.hasChildren

            let namePart = item.name ? `${item.name}` : "";
            let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
            let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
            let specNamePart = item.specName ? `(${item.specName})` : "";
            item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
          })
          this.classList = [{ id: "", allName: "顶级", children: res.data.list }];
          this.allData = JSON.parse(JSON.stringify(this.classList));
          console.log('test', this.allData)
          this.$forceUpdate();
        })
      },
      setValueNull() {
        this.exportParms.productName = ''
      },
      handleClassTypeChange() {
        this.exportParms.productName = ''
        this.getAllClass()
      },
      optionData(array, result = []) {
        array.forEach(item => {
          result.push({
            label: item.name,
            value: item.id
          })
          if (item.children && item.children.length !== 0) {
            this.optionData(item.children, result)
          }
        })
        return JSON.parse(JSON.stringify(result))
      },
      getCustomer() {
        this.getList()
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      handleAddCode(id) {
        this.$router.push({ path: '/store/addCode' })
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          wareStatus: this.wareStatus,
          ...this.queryParam
        }
        selectLogBatchList(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
      codeDetail(row) {
        this.$router.push({ path: '/store/logCodeDetail', query: { id: row.id, source: 2, isWarehouse: row.isWarehouse } })
      },
      searchList(val) {
        this.queryParam = val
        this.getList()
      },
      batchDetail(row) {
        this.detailData = row
        if (this.detailData.img) {
          this.detailData.imgList = JSON.parse(this.detailData.img)
        }
        this.dialogVisible = true
      },
      delBatch(row) {
        // 删除
        let params = {
          id: row.id
        }
        this.$confirm('此操作将永久删除该批次, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          back(params).then(res => {
            if (res.code === 200) {
              this.$message("删除成功")
              this.getList()
            }
          })
        })
      },
      exportLog() {
        this.dialogVisible1 = true
        this.getAllClass()
        // 默认赋值一个月的时间
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        this.exportParms.startDate = this.dateFormat(start, 'yyyy-MM-dd')
        this.exportParms.endDate = this.dateFormat(end, 'yyyy-MM-dd')
      },
      confirmExport() {
        // 这里添加导出逻辑
        console.log('开始时间:', this.exportParms.startDate);
        console.log('结束时间:', this.exportParms.endDate);
        let params = {
          startTime: this.exportParms.startDate,
          endTime: this.exportParms.endDate,
          type: 2,
          createBy: this.exportParms.createBy,
          productName: this.exportParms.productName,
          classType: this.exportParms.classType
        }
        exportExcle(params).then(res => {
          if (res.code === 200) {
            console.log(baseUrl);
            let urls = baseUrl + res.data;
            const link = document.createElement("a");
            link.href = urls;
            link.style.display = "none";
            link.download = "出库清单.xlsx"; // 设置下载的文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.$message({
              type: "success",
              message: "导出成功",
            });
          }
        })

        // 调用导出接口或其他处理逻辑
        this.dialogVisible1 = false; // 关闭对话框
      },
    },

  }
</script>
<style scoped>
  .pageBox {
    display: flex;
    justify-content: flex-end;
  }
</style>